// noinspection JSVoidFunctionReturnValueUsed
const projectIndex = "projects-index";
const subProjectIndex = "subprojects-index";

let envDomain, azKey;
if (false) {
    envDomain = "dev-search-cultec";
    azKey = "KsQG2cNzg7REIWDjJ4IkYIXSrVAnqyCCybrloHTmyHAzSeDKSfuL";
} else {
    envDomain = process.env.REACT_APP_AZURE_SEARCH_API_DOMAIN;
    azKey = process.env.REACT_APP_AZURE_SEARCH_API_KEY;
}

const SEARCH_PROJECTS_ENDPOINT = `https://${envDomain}.search.windows.net/indexes/${projectIndex}/docs/search?api-version=${process.env.REACT_APP_AZURE_SEARCH_API_VER}`;
const SEARCH_SUBPROJECTS_ENDPOINT = `https://${envDomain}.search.windows.net/indexes/${subProjectIndex}/docs/search?api-version=${process.env.REACT_APP_AZURE_SEARCH_API_VER}`;
const UPDATE_PROJECTS_ENDPOINT = `https://${envDomain}.search.windows.net/indexes/${projectIndex}/docs/index?api-version=${process.env.REACT_APP_AZURE_SEARCH_API_VER}`;
const UPDATE_SEARCH_MINICAD = `https://${process.env.REACT_APP_ENVIRONMENT}-cultec.azurewebsites.net/api/automationsearch`;

/**
 * MiniCADAPI Class and methods to communicate with the backend
 */
export default class MiniCADAPI_SEARCH{

    static async getSearchProjects(
        config = {
            PartitionKey: "xxx",
            engineer: null,
            orderBy: { createdDate: "desc" },
            top: 20,
            skip: 0,
        },
    ) {
        // CONFIG
        let top, skip = 0;
        if (config && config.top) {
            top = config.top;
        }
        if (config && config.skip) {
            skip = config.skip;
        }

        // FILTERS
        let filter = "";
        if (config && config.PartitionKey) {
            filter = `${filter} PartitionKey eq '${config.PartitionKey}' and`;
        }

        if (config && config.engineer) {
            filter = `${filter} engineer eq '${config.engineer}' and`;
        }

        filter = `${filter} active eq true`;

        // ORDER BY
        let orderby = "";
        if (config && config.orderBy && config.orderBy.createdDate) {
            orderby = `createdDate ${config.orderBy.createdDate}`;
        }

        let response = await fetch(
            SEARCH_PROJECTS_ENDPOINT,
            {
                method: "POST",
                body: JSON.stringify({
                    search: "*",
                    queryType: "simple",
                    select: "*",
                    filter,
                    orderby,
                    count: true,
                    top,
                    skip,
                }),
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "api-key": azKey,
                },
            });
        let result;
        try {
            result = await response.json();
        } catch (e) {
            result = {};
        }
        return result;
    }


    static async getSearchSubProjects(
        config = {
            engineer: "palacios",
            orderBy: { createdDate: "desc" },
            top: 20,
            skip: 0,
        },
    ) {
        // FILTERS
        let filter = "";
        if (config && config.PartitionKey) {
            // filter = `${filter} search.ismatch('${config.PartitionKey}', 'PartitionKey') and`;
            filter = `${filter} PartitionKey eq '${config.PartitionKey}' and`;
        }
        if (config && config.parentProjectId) {
            // filter = `${filter} search.ismatch('${config.parentProjectId}', 'parentProjectId') and`;
            filter = `${filter} parentProjectId eq '${config.parentProjectId}' and`;
        }
        filter = `${filter} active eq true`;

        let response = await fetch(
            SEARCH_SUBPROJECTS_ENDPOINT,
            {
                method: "POST",
                body: JSON.stringify({
                    search: "*",
                    queryType: "simple",
                    select: "*",
                    // filter: "search.ismatch('mb*', 'projectName') and search.ismatch('palacios*', 'engineer') and active eq true",
                    filter,
                    //orderby,
                    count: true,
                    //top,
                    //skip,
                }),
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "api-key": azKey,
                },
            });
        let result;
        try {
            result = await response.json();
        } catch (e) {
            result = {};
        }
        return result;
    }

    static async mergeOrUploadProjectDocument(
        config = {
            project: null,
            PartitionKey: null,
        },
    ) {
        let result;
        if (config && config.project) {
            try {

                const value = {
                    "@search.action": "mergeOrUpload",
                    "RowKey": config.project.id,
                    "PartitionKey": config.PartitionKey,
                    "Timestamp": config.project.Timestamp,
                    "active": config.project.active,
                    "bomFileUrl": config.project.bomFileUrl,
                    "bomFileUrlPipe": config.project.bomFileUrlPipe,
                    "city": config.project.city,
                    "createdDate": config.project.createdDate,
                    "editedDate": config.project.editedDate,
                    "engineer": config.project.engineer,
                    "inputFileURL": config.project.inputFileURL,
                    "outputFileURL": config.project.outputFileURL,
                    "outputFileURLPipe": config.project.outputFileURLPipe,
                    "processingStatus": config.project.processingStatus,
                    "processingStep": "",
                    "projectName": config.project.projectName,
                    "projectType": config.project.projectType,
                    "state": config.project.state,
                    "statusDate": config.project.statusDate,
                    "workItemId": config.project.workItemId,
                    "isMultiBedProject": config.project.isMultiBedProject,
                    "country": config.project.country,
                    "region": config.project.region,
                    "language": config.project.language,
                };

                let response = await fetch(
                    UPDATE_SEARCH_MINICAD,
                    {
                        method: "POST",
                        body: JSON.stringify({
                            "value": value,
                        }),
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                        },
                    });

                /*let response = await fetch(
                    UPDATE_PROJECTS_ENDPOINT,
                    {
                        method: "POST",
                        body: JSON.stringify({
                            "value": [
                                ...value
                            ],
                        }),
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            "api-key": azKey,
                        },
                    });*/

                result = await response;
            } catch (e) {
                console.error(`MiniCADAPI_SEARCH.mergeOrUploadProjectDocument() :: ${e.message}`);
                result = {};
            }
        } else {
            result = {};
        }
        return result;
    }

    static async deleteProjectDocument(
        config = {
            project: null,
        },
    ) {
        let result;
        if (config && config.project && config.project.id) {
            try {

                const value = {
                    "@search.action": "delete",
                    "RowKey": config.project.id,
                };
                let response = await fetch(
                    UPDATE_SEARCH_MINICAD,
                    {
                        method: "POST",
                        body: JSON.stringify({
                            "value": value,
                        }),
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                        },
                    });

                /*let response = await fetch(
                    UPDATE_PROJECTS_ENDPOINT,
                    {
                        method: "POST",
                        body: JSON.stringify({
                            "value": [
                                ...value
                            ],
                        }),
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            "api-key": azKey,
                        },
                    });*/
                result = await response;
            } catch (e) {
                console.error(`MiniCADAPI_SEARCH.deleteProjectDocument() :: ${e.message}`);
                result = {};
            }
        } else {
            result = {};
        }
        return result;
    }


}



// WEBPACK FOOTER //
// ./src/lib/MiniCADAPI_SEARCH.js